export const handleValidation = (userPhone) => {
  if (!userPhone) throw "Please provide a valid phone number";

  const phone = userPhone.replace(/^(\+351|00351)|[\s]/g, '');
  
  const phoneRegex = /^9\d{8}$/;
  if (!phoneRegex.test(phone)) {
      throw "Please provide a valid phone number";
  }
};